<div>
  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <span *ngIf="cycleInfo">Ciclo {{ currentCycle + 1 }} di {{ cycleInfo.repeat }}</span>
      </ion-col>
    </ion-row>

    <ion-row>
      
      <ion-col size="auto" class="c3-flex ion-align-items-center" *ngIf="cycleInfo">
        <ion-button
          (click)="onPrevCycle()"
          c3Tooltip="Ciclo precedente"
          fill="clear"
          [disabled]="currentCycle === 0"
        >
          <ion-icon slot="icon-only" [src]="'chevron-left' | getIcon"></ion-icon>
        </ion-button>
      </ion-col>

      
      <ion-col>
        <ion-grid>
          <ion-row>
            <ng-container *ngFor="let aIndex of currentCycleIndexes">
              <ion-col size="12" size-md="3" size-lg="1.7142857142857142">
                <ng-container [ngSwitch]="aIndex">
                  
                  <ng-container *ngSwitchCase="null">
                    <div class="cal-assumption-item"></div>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <div
                      class="cal-assumption-item ion-activatable"
                      (click)="onSelectDay(aIndex)"
                      [ngClass]="{ 'cal-assumption-item-current': aIndex === currentDayIndex }"
                      #calAssumptionItem
                      *ngIf="formAssumptions.at(aIndex)?.get('assumptions'); let dailyAssumptions"
                    >
                      

                      <div
                        class="cal-assumption-item-header c3-flex ion-align-items-center ion-justify-content-between"
                      >
                        <span>
                          Giorno {{ aIndex + 1 }}
                          <small
                            *ngIf="aIndex - startPadding | toAbsDay: therapyStartDay; let dayDate"
                          >
                            ({{ dayDate | date: "shortDate" }})
                            <ion-text color="tertiary" *ngIf="dayDate | isSameDay: 'today'">
                              - <strong>Oggi</strong>
                            </ion-text>
                          </small>
                        </span>

                        <ion-buttons *c3ShowOnHover="calAssumptionItem">
                          <ion-button
                            class="item-btn"
                            (click)="onRemoveAssumption(aIndex)"
                            color="danger"
                            c3Tooltip="Rimuovi"
                            *ngIf="formAssumptions.at(aIndex)?.enabled"
                          >
                            <ion-icon slot="icon-only" [src]="'delete' | getIcon"></ion-icon>
                          </ion-button>
                        </ion-buttons>
                      </div>

                      <div>
                        <ng-container [ngSwitch]="dailyAssumptions.length">
                          <ng-container *ngSwitchCase="0">
                            <ion-note color="tertiary" class="ion-text-wrap">
                              <small> Nessuna assunzione prevista </small>
                            </ion-note>
                          </ng-container>

                          <ng-container *ngSwitchDefault>
                            <div *ngFor="let a of dailyAssumptions.controls">
                              <ion-note>
                                <small>
                                  <ion-text [color]="a.value?.quantity ? undefined : 'danger'">
                                    {{ a.value?.quantity || "n.d." }}
                                  </ion-text>
                                  {{
                                    a.value?.unit
                                      | clinicalDataTranslation: ClinicalDataType.THERAPY
                                  }}
                                  <ion-text [color]="a.value?.time ? undefined : 'danger'">
                                    alle {{ a.value?.time || "n.d." }}
                                  </ion-text>
                                </small>
                              </ion-note>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ion-col>
            </ng-container>

            <ion-col
              size="12"
              size-md="3"
              size-lg="1.7142857142857142"
              c3Tooltip="Non puoi inserire più giorni di quelli previsti dalla durata della terapia"
              [c3TooltipIf]="maxDays && maxDays <= formAssumptions.length"
              *ngIf="
                formAssumptions.enabled &&
                (!cycleInfo || currentCycleIndexes.length < cycleInfo.duration)
              "
            >
              <div
                class="cal-assumption-item c3-flex ion-align-items-center ion-justify-content-center"
              >
                <ion-button
                  (click)="onAddAssumption()"
                  fill="clear"
                  color="secondary"
                  [disabled]="maxDays && maxDays <= formAssumptions.length"
                >
                  <span class="ion-text-wrap">Aggiungi Giorno</span>
                  <br />
                  <ion-icon [src]="'plus' | getIcon"></ion-icon>
                </ion-button>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>

      
      <ion-col size="auto" class="c3-flex ion-align-items-center" *ngIf="cycleInfo">
        <ion-button
          (click)="onNextCycle()"
          c3Tooltip="Ciclo successivo"
          fill="clear"
          [disabled]="currentCycle + 1 >= cycleInfo.repeat"
        >
          <ion-icon slot="icon-only" [src]="'chevron-right' | getIcon"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid *ngIf="currentDayIndex || currentDayIndex === 0">
    <ion-row>
      <ion-col size="12">
        <h5>
          Assunzioni giornaliere per il <strong>{{ currentDayIndex + 1 }}°</strong> giorno
        </h5>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        

        <app-hint-msg
          *ngIf="$any(formAssumptions.at(currentDayIndex))?.get('assumptions').length === 0"
        >
          <ion-note>
            Non sono previste assunzioni per questo giorno. Se si desidera aggiungerne una, cliccare
            sul bottone sottostante.
          </ion-note>
        </app-hint-msg>

        <ion-list>
          <ion-item
            *ngFor="
              let a of $any(formAssumptions.at(currentDayIndex))?.get('assumptions').controls;
              let j = index;
              trackBy: trackByAssumption
            "
            [formGroup]="a"
          >
            <ion-label slot="start"
              ><strong>{{ j + 1 }}</strong></ion-label
            >

            <div class="c3-flex c3-flex-wrap ion-align-items-center">
              <span>Il paziente assumerà </span>

              
              <div>
                <ion-input
                  type="number"
                  placeholder="Quantità"
                  min="0"
                  formControlName="quantity"
                  required
                  class="short-input ion-text-center"
                >
                </ion-input>
              </div>

              <span class="ion-text-lowercase">
                &nbsp;{{ assumptionUnit || "" | clinicalDataTranslation: ClinicalDataType.THERAPY }}
              </span>

              <span>&nbsp;alle ore</span>

              
              <div>
                <ion-input type="time" formControlName="time" required class="short-input">
                </ion-input>
              </div>

              <span>&nbsp;nel seguente momento della giornata:</span>

              
              <div>
                <ion-select
                  placeholder="Momento della giornata"
                  formControlName="moment"
                  interface="popover"
                  [interfaceOptions]="{
                    showBackdrop: false,
                    cssClass: 'app-popover-select-overflow'
                  }"
                  class="moment-selector"
                >
                  <ion-select-option
                    *ngFor="
                      let item of DAY_MOMENTS | keyvalue: sortAlphabetically;
                      trackBy: trackByValue
                    "
                    [value]="item.key"
                  >
                    <span>{{ item.value }}</span>
                  </ion-select-option>
                </ion-select>
              </div>
            </div>

            <ion-buttons slot="end">
              <ion-button
                (click)="onRemoveDailyAssumption(currentDayIndex, j)"
                color="danger"
                *ngIf="a.enabled"
              >
                <ion-icon slot="end" [src]="'delete' | getIcon"></ion-icon>
                <span>Rimuovi</span>
              </ion-button>
            </ion-buttons>
          </ion-item>
        </ion-list>

        <ion-button
          (click)="onAddDailyAssumption(currentDayIndex)"
          fill="clear"
          color="secondary"
          *ngIf="$any(formAssumptions.at(currentDayIndex))?.get('assumptions').enabled"
        >
          <span>Aggiungi Assunzione</span>
          <ion-icon slot="end" [src]="'plus' | getIcon"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>

    
    <ion-row *ngIf="formAssumptions.enabled">
      <ion-col
        size="12"
        *ngIf="$any(formAssumptions.at(currentDayIndex))?.get('assumptions').length > 0"
      >
        <h6>Modifiche in batch</h6>
        <p>
          <ion-note>
            Applica le assunzioni programmate per questo giorno anche ai giorni successivi
          </ion-note>
        </p>

        <ion-item lines="none">
          <ion-checkbox
            slot="start"
            [(ngModel)]="bulkEditApplyAlsoToPauseDays"
            color="secondary"
          ></ion-checkbox>
          <ion-label
            >Applica questo schema anche ai giorni in cui non è prevista alcuna
            assunzione</ion-label
          >
        </ion-item>

        <ion-buttons>
          <ion-button
            color="secondary"
            (click)="onBulkEdit({ fromIndex: currentDayIndex, type: 'to-cycle-end' })"
            *ngIf="cycleInfo"
            fill="outline"
          >
            Applica fino alla fine del ciclo
          </ion-button>

          <ion-button
            color="secondary"
            (click)="onBulkEdit({ fromIndex: currentDayIndex, type: 'to-therapy-end' })"
            fill="outline"
          >
            Applica fino alla fine della terapia
          </ion-button>
        </ion-buttons>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
